<div class="lum-c-ui-expand-all-ag-grid">
  <button type="button" class="linkish" (click)="onExpandAllClick()">
    <i
      class="fa"
      [ngClass]="isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"
    ></i>
  </button>
</div>
